import { Component, Input } from '@angular/core';
import {
  Router,
  NavigationStart,
  RouteConfigLoadStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RouteConfigLoadEnd,
} from '@angular/router';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  /**
   * Establece si el loader se debe mostrar cuando se navega entre rutas
   */
  @Input()
  activarLoaderNavegacionRutas = false;

  constructor(public loaderService: LoaderService, private router: Router) {}

  ngOnInit() {
    if (this.activarLoaderNavegacionRutas) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart || event instanceof RouteConfigLoadStart) {
          this.loaderService.activar();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationError ||
          event instanceof NavigationCancel ||
          event instanceof RouteConfigLoadEnd
        ) {
          this.loaderService.desactivar();
        }
      });
    }
  }
}
